/* eslint-disable camelcase */
import { analytics } from '@y2/google-tag-manager/v2/synchronized';
import { categories } from '@y2/categories';

const {
  realEstate: {
    subCategories: { yad1 },
    id,
  },
} = categories;

export const pushPageEvent = (userId?: string) =>
  analytics.pushPageEvent({
    PageType: 'item',
    Section: 'yad1',
    Category: String(yad1.id),
    SubCategory: String(id),
    ...(userId && { UserID: userId }),
  });
